import { useEffect, useState } from "react";
import SectionHeader from "../include/SectionHeader";
import BlogCard from "./partials/BlogCard";
import "./Blog.css";
import Categories from "./partials/Categories";
import Search from "../include/Search";
import api from "../../services/api";

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState("");
  const [activeCategory, setActiveCategory] = useState("All");

  useEffect(() => {
    api.get("/api/blogs").then(res => {
      setBlogs(res.data);
      setLoading(false);
    });
    api.get("/api/blog-categories").then(res => {
      setCategories(res.data);
      setLoading(false);
    });
  }, []);
  
  const searchResults = blogs.filter(blog => {
    const title = blog.title ? blog.title.toLowerCase() : "";
    const subtitle = blog.subtitle ? blog.subtitle.toLowerCase() : "";

    return (
      title.includes(search.toLowerCase()) ||
      subtitle.includes(search.toLowerCase())
    );
  });

  const categoryResults =
    activeCategory === "All"
      ? blogs
      : blogs.filter(blog =>
          blog.categories.some(cat => cat.name === activeCategory)
        );

  const BlogListSkeleton = () => (
    <div className="blog-list-section py-5">
      <div className="container">

        <div className="skeleton mb-4">
          <div className="skeleton-line medium shimmer"></div>
          <div className="skeleton-line long shimmer"></div>
        </div>

        <div className="skeleton mb-4">
          <div
            className="shimmer"
            style={{ height: "46px", borderRadius: "30px", background: "#e0e0e0" }}
          ></div>
        </div>

        <div className="row">
          {[1, 2, 3].map((i) => (
            <div className="col-md-4 col-sm-6 mb-2" key={i}>
              <div className="skeleton">
                <div
                  className="shimmer mb-3"
                  style={{ height: "200px", borderRadius: "12px", background: "#e0e0e0" }}
                ></div>
                <div className="skeleton-line short shimmer"></div>
                <div className="skeleton-line medium shimmer"></div>
              </div>
            </div>
          ))}
        </div>

        <div className="skeleton">
          <div className="skeleton-line medium shimmer mb-3"></div>

          <div className="d-flex flex-wrap gap-3">
            {[1, 2, 3, 4, 5].map((i) => (
              <div
                key={i}
                className="shimmer"
                style={{
                  width: "110px",
                  height: "38px",
                  borderRadius: "20px",
                  background: "#e0e0e0",
                }}
              ></div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
  
  if (loading) return <BlogListSkeleton />

  return (
    <div className="blog-list-section py-5">
      <div className="container">

        <SectionHeader
          title="Lifeline Blogs"
          subtitle="Check out our latest scoops on healthcare"
        />

        <div className="row">
          <div className="col-12">
            <Search onSearch={(value) => setSearch(value)} />
          </div>
        </div>

        <div className="row search-result">
          {searchResults.map((blog, index) => (
            <BlogCard
              key={index}
              title={blog.title}
              subtitle={blog.subtitle}
              img={blog.main_image}
              author={blog.author}
              slug={`/blog-details/${blog.slug}`}
            />
          ))}
        </div>

        <SectionHeader title="Categories" />

        <div className="row categories-result">
          <div className="col-12">
            <Categories
              categories={categories}
              active={activeCategory}
              onSelect={(cat) => setActiveCategory(cat)}
            />
          </div>

          {categoryResults.map((blog, index) => (
            <BlogCard
              key={index}
              title={blog.title}
              subtitle={blog.subtitle}
              img={blog.main_image}
              author={blog.author}
              slug={`/blog-details/${blog.slug}`}
            />
          ))}
        </div>

      </div>
    </div>
  );
};

export default BlogList;
